import React, { Component } from 'react'
import { router } from 'router'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic, Expo } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import Scroller from 'src/utils/scroller'
import components from 'src/utils/components'

export default class MenuMobile extends Component {
  constructor(props) {
    super(props)

    this.menu = ['', '', '', '']
    this.state = {
      items: []
    }
  }

  componentDidUpdate() {
    this.state.items[2] && !this.tlAnimateWorld && this.initTL()
  }

  initTL() {
    if (this.tlAnimateInOut) {
      this.tlAnimateInOut.pause(0, true)
      this.tlAnimateInOut.remove()
    }

    this.tlAnimateInOut = new TimelineMax({
      paused: true
    })
      .fromTo(
        this.refs.component,
        1,
        {
          x: '100%'
        },
        { x: '0%', ease: Expo.easeOut },
        0
      )
      .fromTo(
        this.refs.mask,
        1,
        {
          x: '-100%'
        },
        { x: '0%', ease: Expo.easeOut },
        0
      )

    this.$items = [this.refs.itemLanguage]
    this.state.items.map((item, i) => {
      this.$items.push(this.refs[`item${i}`])
    })

    const rItems = this.$items.reverse()

    this.tlAnimateInOut
      .to(
        this.refs.rotateTop,
        0.6,
        {
          rotation: 135,
          ease: Expo.easeOut
        },
        0
      )
      .to(
        this.refs.rotateBtm,
        0.6,
        {
          rotation: 45,
          ease: Expo.easeOut
        },
        0.1
      )

    if (!this.refs.menuWorld) return

    this.$worlds = [this.refs.btn]
    this.props.worlds.map((world, i) => {
      this.$worlds.push(this.refs[`world${i}`])
    })

    this.tlAnimateWorld = new TimelineMax({
      paused: true
    })
      .staggerTo(
        rItems,
        1.5,
        {
          autoAlpha: 0,
          x: -50,
          ease: Expo.easeOut
        },
        0.1,
        0
      )
      .to(this.refs.menuContainer, 0.1, { autoAlpha: 0 }, 0.6)
      .fromTo(this.refs.menuWorld, 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0.6)
      .staggerFromTo(
        this.$worlds,
        1.5,
        {
          autoAlpha: 0,
          x: 50
        },
        {
          autoAlpha: 1,
          x: 0,
          ease: Expo.easeOut
        },
        0.1,
        0.6
      )

    this.tlAnimateWorldOut = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.tlAnimateInOut.pause(0)
        this.tlAnimateInOut.progress(0)

        this.tlAnimateWorld.pause()
        this.tlAnimateWorld.progress(0)
      }
    })
      .to(
        this.refs.component,
        1,
        {
          x: '100%',
          ease: Expo.easeOut
        },
        0.3
      )
      .to(
        this.refs.mask,
        1,
        {
          x: '-100%',
          ease: Expo.easeOut
        },
        0.3
      )
      .to(
        this.refs.rotateTop,
        0.6,
        {
          rotation: 45,
          ease: Expo.easeOut
        },
        0
      )
      .to(
        this.refs.rotateBtm,
        0.6,
        {
          rotation: -45,
          ease: Expo.easeOut
        },
        0.1
      )

    this.$languages = [this.refs.btnLanguage]
    this.props.switcher.map((lang, i) => {
      this.$languages.push(this.refs[`switcher${i}`])
    })

    this.tlAnimateLanguage = new TimelineMax({
      paused: true
    })
      .staggerTo(
        rItems,
        1.5,
        {
          autoAlpha: 0,
          x: -50,
          ease: Expo.easeOut
        },
        0.1,
        0
      )
      .to(this.refs.menuContainer, 0.1, { autoAlpha: 0 }, 0.6)
      .fromTo(
        this.refs.menuLanguage,
        0.1,
        { autoAlpha: 0 },
        { autoAlpha: 1 },
        0.6
      )
      .staggerFromTo(
        this.$languages,
        1.5,
        {
          autoAlpha: 0,
          x: 50
        },
        {
          autoAlpha: 1,
          x: 0,
          ease: Expo.easeOut
        },
        0.1,
        0.6
      )
  }

  addItem(obj) {
    this.menu[obj.order] = obj

    this.setState({
      items: this.menu
    })
  }

  onClickItem(i) {
    if (i === 3) {
      components.allComponents.home.refs.pageContainer.scrollTop = 0
      this.tlAnimateInOut.timeScale(3).reverse()
      components.allComponents.homePlayer.animateIn()
    } else if (i === 2) {
      this.tlAnimateWorld.timeScale(1).play(0)
    } else {
      if (values.viewport.width < config.bp.md) {
        window.scrollTo(0, this.state.items[i].top - 90)
      } else {
        Scroller.activate()
        Scroller.scrollTo(this.state.items[i].top - 90, 0).then()
      }

      this.tlAnimateInOut.timeScale(2).reverse()
    }
  }

  animateIn() {
    this.tlAnimateWorld.pause()
    this.tlAnimateWorld.progress(0)
    this.tlAnimateLanguage.pause()
    this.tlAnimateLanguage.progress(0)
    this.tlAnimateWorldOut.pause()
    this.tlAnimateWorldOut.progress(0)

    Scroller.desactivate()
    this.tlAnimateInOut.timeScale(1).play(0)
  }

  onClickClose = () => {
    if (
      this.tlAnimateWorld.progress() > 0 ||
      this.tlAnimateLanguage.progress() > 0
    ) {
      this.tlAnimateWorldOut.play(0)
    } else {
      this.tlAnimateInOut.timeScale(2).reverse()
    }
  }

  goToWorld = url => {
    const ctx = router.getContext()
    this.tlAnimateWorldOut.play(0)
    router.goto(router.getRoute('world', { param: url }, ctx.locale))
  }

  goToHome = url => {
    this.tlAnimateWorldOut.play(0)
    router.goto(`/${url}`)
  }

  onClickTitle = () => {
    this.tlAnimateWorld.timeScale(2).reverse()
  }

  onClickLanguage = () => {
    this.tlAnimateLanguage.timeScale(1).play()
  }

  onClickLanguageOut = () => {
    this.tlAnimateLanguage.timeScale(2).reverse()
  }

  render() {
    return (
      <div ref="component" className="component menu-mobile m-grid-12">
        <div ref="mask" className="mask">
          <div className="wrapper-header">
            <div className="m-grid-10 container-header">
              <div className="container-logo">
                <img
                  ref="logo"
                  src={`${process.env.PUBLIC_URL}/img/chaumet-white.png`}
                />
              </div>
            </div>
            <span onClick={this.onClickClose} ref="close" className="close">
              <span ref="rotateTop" className="line rotate-top" />
              <span ref="rotateBtm" className="line rotate-btm" />
            </span>
          </div>
          <div ref="menuContainer" className="menu-container m-grid-10">
            <div
              onClick={this.onClickLanguage}
              ref="itemLanguage"
              className="item">
              <p ref="clBtn">{this.props.currentLanguage.title}</p>

              <span ref="arrowBtm" className="arrow">
                <span className="middle" />
                <span className="top" />
                <span className="btm" />
              </span>
            </div>
            {this.state.items.map((item, i) => {
              return (
                <div
                  onClick={this.onClickItem.bind(this, i)}
                  key={`item${i}`}
                  ref={`item${i}`}
                  className="item">
                  <p ref={`btn${i}`}>{item.legend}</p>
                  {i === 2 && (
                    <span ref="arrowBtm" className="arrow">
                      <span className="middle" />
                      <span className="top" />
                      <span className="btm" />
                    </span>
                  )}
                </div>
              )
            })}
          </div>
          {this.state.items[2] && (
            <div ref="menuWorld" className="menu-container-world m-grid-10">
              <div
                onClick={this.onClickTitle}
                key={`btn`}
                ref="btn"
                className="item">
                <p ref="title">{this.state.items[2].legend}</p>
                <span ref="arrow" className="arrow arrow-rotate">
                  <span className="middle" />
                  <span className="top" />
                  <span className="btm" />
                </span>
              </div>
              {this.props.worlds.map((item, i) => {
                return (
                  <div
                    onClick={this.goToWorld.bind(this, item.url)}
                    key={`world${i}`}
                    ref={`world${i}`}
                    className="world">
                    <p ref={`btn${i}`}>{item.title}</p>
                  </div>
                )
              })}
            </div>
          )}
          {this.props.currentLanguage && (
            <div ref="menuLanguage" className="menu-container-world m-grid-10">
              <div
                onClick={this.onClickLanguageOut}
                ref="btnLanguage"
                className="item">
                <p ref="titleLanguage">{this.props.currentLanguage.title}</p>
                <span ref="arrow" className="arrow arrow-rotate">
                  <span className="middle" />
                  <span className="top" />
                  <span className="btm" />
                </span>
              </div>
              {this.props.switcher.map((item, i) => {
                return (
                  <div
                    onClick={this.goToHome.bind(this, item.lang)}
                    key={`switcher${i}`}
                    ref={`switcher${i}`}
                    className="world">
                    <p ref={`btnSwitcher${i}`}>{item.title}</p>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/menu-mobile/index.js